const PreviewGallery = (function() {
	let defaultConfig = {
		selector: null,
		asNavFor: null,
		perPage: 1,
		startIndex: 0,
		navigation: null,
		swipe: false,
		onInit: () => {},
		onChange: () => {},
		onResize: () => {}
	};

	return class {
		constructor(props) {
			this.pagination = null;
			this.config = $.extend({}, defaultConfig, props);
			this.innerElements = this.config.selector.children();
			this.selector = this.config.selector;
			this.selectorWidth = this.selector.width();

			this.resolveSlidesNumber();

			this.currentSlide = Math.max(
				0,
				Math.min(
					this.config.startIndex,
					this.innerElements.length - this.config.perPage
				)
			);

			this.init();
			this.attachEvents();

			this.next = this.next.bind(this);
			this.prev = this.prev.bind(this);
		}

		init() {
			if (this.config.asNavFor) {
				this.asNavFor = new PreviewGallery({
					selector: this.config.asNavFor
				});
			}

			if (this.config.navigation) {

				this.config.navigation.find('.next').attr('hidden', this.innerElements.length <= this.perPage);
				this.selector.addClass('first-slide');
			}

			this.buildSliderFrame();

			this.config.onInit.call(this);

			this.slideToCurrent();
		}

		attachEvents() {
			if (this.config.asNavFor) {
				this.sliderFrame.on('click', '> *', e => {
					const position = $(e.currentTarget).index();
					this.asNavFor.goTo(position);
				});
			}

			if (this.config.navigation) {

				this.config.navigation
					.on('click', '.js-carousel-next', () => {
						const scrollBy = Math.floor(this.perPage);
						this.next(scrollBy);
					})
					.on('click', '.js-carousel-prev', () => {
						const scrollBy = Math.floor(this.perPage);
						this.prev(scrollBy);
					});
			}

			if (this.config.swipe) {

				this.selector.swipe({
					swipe: (event, direction) => {
						const scrollBy = Math.floor(this.perPage);

						if (direction === 'left') {
							this.next(scrollBy);
						} else if (direction === 'right') {
							this.prev(scrollBy);
						}
					},
					allowPageScroll:'auto'
				});
			}

			let windowX = window.outerWidth;
			let windowY = $(window).height();

			$(window).on('resize', () => {
				let height = $(window).height();
				let width = window.outerWidth;
				if (height !== windowY || width !== windowX) {
					this.onWindowResize();
					windowY = height;
					windowX = width;
				}
			});
		}

		buildSliderFrame() {
			if (!this.selectorWidth) return;

			const widthItem = this.selectorWidth / this.config.perPage;

			this.sliderFrame = $('<div />');
			this.sliderFrame.width(widthItem * this.innerElements.length);

			const slides = this.innerElements
				.clone()
				.width(`${100 / this.innerElements.length}%`);

			this.sliderFrame.append(slides);
			this.selector.html(this.sliderFrame);

			this.sliderFrame.on('transitionend webkitTransitionEnd oTransitionEnd', () => {
				this.config.onChange.call(this);
			});

			this.slideToCurrent();
		}

		slideToCurrent() {
			const offset =
				-1 * this.currentSlide * (this.selectorWidth / this.config.perPage);

			this.sliderFrame.css('transform', `translate3d(${offset}px, 0, 0)`);

			if (this.pagination) {

				this.updatePagination();
			}

			if (this.config.navigation) {

				const firstSlide = this.currentSlide === 0;
				this.config.navigation.find('.prev').attr('hidden', firstSlide);

				const lastSlide = this.currentSlide === this.innerElements.length - this.perPage;
				this.config.navigation.find('.next').attr('hidden', this.innerElements.length <= this.perPage || lastSlide);

				this.selector
					.toggleClass('last-slide', lastSlide)
					.toggleClass('first-slide', firstSlide);
			}
		}

		updatePagination() {
			this.pagination.children()
				.eq(this.currentSlide)
				.addClass('is-active')
				.siblings()
				.removeClass('is-active');
		}

		goTo(index) {
			if (this.innerElements.length <= this.config.perPage) {
				return;
			}

			const beforeChange = this.currentSlide;
			this.currentSlide = Math.min(
				Math.max(index, 0),
				this.innerElements.length - this.config.perPage
			);

			if (beforeChange !== this.currentSlide) {
				this.slideToCurrent();
				this.config.onChange.call(this);
			}
		}

		next(slidesToMove = 1) {
			// early return when there is nothing to slide
			if (this.innerElements.length <= this.config.perPage) {
				return;
			}

			this.currentSlide = Math.min(
				this.currentSlide + slidesToMove,
				this.innerElements.length - this.config.perPage
			);

			this.slideToCurrent();
			this.config.onChange.call(this);
		}

		prev(slidesToMove = 1) {
			// early return when there is nothing to slide
			if (this.innerElements.length <= this.config.perPage) {
				return;
			}

			this.currentSlide = Math.max(this.currentSlide - slidesToMove, 0);

			this.slideToCurrent();
			this.config.onChange.call(this);
		}

		addPagination(selector) {
			for (let i = 0; i < this.innerElements.length; i++) {
				const btn = $('<span />');
				this.pagination = $(selector);
				this.pagination = $(selector).append(btn);
			}

			this.pagination.on('click', 'span', (e) => {
				const index = $(e.target).index();
				this.goTo(index);
			});

			this.updatePagination();
		}

		resolveSlidesNumber() {
			if (typeof this.config.perPage === 'number') {
				this.perPage = this.config.perPage;
			} else if (typeof this.config.perPage === 'object') {
				this.perPage = 1;
				for (const viewport in this.config.perPage) {
					if (window.innerWidth >= viewport) {
						this.perPage = this.config.perPage[viewport];
					}
				}
			}
		}

		onWindowResize() {
			this.resolveSlidesNumber();

			if (this.currentSlide + this.perPage > this.innerElements.length) {
				this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage;
			}

			this.selectorWidth = this.selector.get(0).offsetWidth;

			this.buildSliderFrame();

			this.config.onResize.call(this);
		}
	};
})();
